const IconButton = ({
  children,
  disabled,
  type,
  className,
  onClick,
  ...props
}) => {
  return (
    <button
      type={type || "submit"}
      className={`btn btn-square mx-2 bg-primary ${className || ""}`}
      disabled={disabled}
      onClick={onClick}
      {...props}
    >
      {children}
    </button>
  );
};

export default IconButton;
